export class DateInputValueConverter {
  toView(value: string | Date): string {
    if (!value) return null;
    // Handle Date objects
    if (value instanceof Date) {
      return value.toISOString().substring(0, 10);
    }
    // Handle string values
    if (typeof value === 'string') {
      return value.substring(0, 10);
    }
    return null;
  }

  fromView(value: string): string | undefined {
    return value === '' ? undefined : value;
  }
}
